const getters = {
  // roles: state => state.user.roles,
  // 菜单state
  menu: state => state.d2admin.menu,
  // 权限
  permission: state => state.d2admin.permission
}

export default getters
